import React from 'react';
import './Loading.css';

function Loading() {
  return (
    <div className="loading-container">
      <div className="loading-spinner-large"></div>
      <p>Loading...</p>
    </div>
  );
}

export default Loading;